/**
 * 客户端websocket
 * @constructor
 */
export var WS = function () {}
WS.prototype = {
  wsUrl: '',
  retryTimes: 0,
  connectInter: null,
  status: 0, // 0:ws未连接，1：ws连接成功，2：客户接入成功，3：坐席分配成功，4：会话断开
  sessionInfo: {
    sessionId: '',
    agentId: ''
  },
  userInfo: {
    clientId: '',
    clientType: 'h5',
    clientIp: '',
    clientIpRegion: '',
    clientOs: '',
    clientBrowse: '',
    sourceSite: '',
    userId: '',
    userName: '',
    custFlag: '',
    userHeadImg: '',
    userGroup: '',
    lastServiceAgentId: 0,
    lastServiceAgentTime: 0,
    tags: [],
    openid: '',
    mobile: '',
    transferType: 2,
    content: '' //第一条消息
  },
  commonFiled: {
    appId: '',
    appName: '',
    orgId: 0,
    version: 1,
    msgType: 0,
    timestamp: 0
  },
  msgType: {
    heartMsg: 1, // 心跳消息
    custAccessMsg: 2, // 客户接入消息
    waitMsg: 3, //客户排队对待消息
    agentAccessMsg: 4, // 坐席分配成功消息
    chatMsg: 5, // 聊天消息
    responseMsg: 6, // 聊天消息应答
    agentStatusChangeMsg: 7, // 坐席状态改变
    agentChangeMsg: 8, // 坐席转接
    sessionOverMsg: 9, // 会话结束
    accessResultMsg: 10, //接入结果应答
    commentMsg: 11, // 评论消息
    notInServiceTimeMsg: 12, // 不在服务时间范围内
    inviteComment: 13, //邀请评价
    cancelMsg: 14, //消息撤回
    serviceSeer: 15, //服务先知
    sessionError: 16, //会话异常消息
    blackMsg: 17 //黑名单消息
  },
  workmsgType: {
    onmessage: 1, //socket消息
    onopen: 2, //链接开启
    onclose: 3, //链接关闭
    onerror: 4, //链接异常
    heartMsg: 5, //心跳
    retry: 10, // 重连
    retryFailed: 11// 重连失败
  },
  isClose: false,
  event: {
    connectSuccess: function () {},
    connectClose: function () {},
    heartbeat: function () {},
    accessSuccess: function () {},
    chatMsgReceived: function () {},
    waitMsgReceived: function () {},
    agentAccessMsgReceived: function () {},
    sessionOverMsgReceived: function () {},
    responseMsgReceived: function () {},
    cancelMsgReceived: function () {},
    serviceSeerReceived: function () {},
    commentMsgReceived: function () {},
    agentChangeMsgReceived: function () {},
    inviteCommentReceived: function () {},
    sessionErrorReceived: function () {}
  },
  /**
   * 获取共通字段
   * @param msgType
   * @returns {any}
   */
  getCommonFiled(msgType) {
    var commonFiled = JSON.parse(JSON.stringify(this.commonFiled))
    commonFiled.msgType = msgType
    commonFiled.timestamp = new Date().getTime()
    return commonFiled
  },
  /**
   * 初始化
   * @param opts
   */
  init: function (opts) {
    // 初始化
    var _this = this
    var ef = function () {}
    var url = opts.url
    var appId = opts.appId
    var appName = opts.appName
    var orgId = opts.orgId
    var userType = opts.userType || 1
    var userId = opts.userId || new Date().getTime()
    var userName = opts.userName || '匿名'
    var custFlag = opts.custFlag || 0
    var userHeadImg = opts.userHeadImg
    var userGroup = opts.userGroup
    var clientId = opts.clientId || new Date().getTime()
    var clientType = opts.clientType || 'h5'
    var clientIp = opts.clientIp || ''
    var clientIpRegion = opts.clientIpRegion || ''
    var clientOs = opts.clientOs || ''
    var clientBrowse = opts.clientBrowse || ''
    var online = opts.online || ''
    var sourceSite = opts.sourceSite || document.referrer
    var lastServiceAgentId = opts.lastServiceAgentId || 0
    var lastServiceAgentTime = opts.lastServiceAgentTime || 0
    var lastSessionTime = opts.lastSessionTime || null
    var groupTags = opts.groupTags || []
    var extendedFields = opts.extendedFields
    var transferType = opts.transferType || 1
    var tags = opts.tags != null ? JSON.stringify(opts.tags) : []
    var openid = opts.openid || 0
    var content = opts.content || null
    var msgContentType = opts.msgContentType || null
    var mobile = opts.mobile || ''
    var connectSuccess = opts.connectSuccess || ef
    var connectClose = opts.connectClose || ef
    var connectRetry = opts.connectRetry || ef
    var heartbeat = opts.heartbeat || ef
    var accessSuccess = opts.accessSuccess || ef
    var chatMsgReceived = opts.chatMsgReceived || ef
    var waitMsgReceived = opts.waitMsgReceived || ef
    var agentAccessMsgReceived = opts.agentAccessMsgReceived || ef
    var sessionOverMsgReceived = opts.sessionOverMsgReceived || ef
    var responseMsgReceived = opts.responseMsgReceived || ef
    var cancelMsgReceived = opts.cancelMsgReceived || ef
    var serviceSeerReceived = opts.serviceSeerReceived || ef
    var commentMsgReceived = opts.commentMsgReceived || ef
    var agentChangeMsgReceived = opts.agentChangeMsgReceived || ef
    var inviteCommentReceived = opts.inviteCommentReceived || ef
    var sessionErrorReceived = opts.sessionErrorReceived || ef
    _this.isClose = false
    _this.wsUrl = url
    _this.commonFiled.appId = appId
    _this.commonFiled.appName = appName
    _this.commonFiled.orgId = orgId
    _this.userInfo.userType = userType
    _this.userInfo.userId = userId
    _this.userInfo.userName = userName
    _this.userInfo.custFlag = custFlag
    _this.userInfo.userHeadImg = userHeadImg
    _this.userInfo.userGroup = userGroup
    _this.userInfo.clientId = clientId
    _this.userInfo.clientType = clientType
    _this.userInfo.clientIp = clientIp
    _this.userInfo.clientIpRegion = clientIpRegion
    _this.userInfo.clientOs = clientOs
    _this.userInfo.clientBrowse = clientBrowse
    _this.userInfo.online = online
    _this.userInfo.sourceSite = sourceSite
    _this.userInfo.lastServiceAgentId = lastServiceAgentId
    _this.userInfo.lastServiceAgentTime = lastServiceAgentTime
    _this.userInfo.lastSessionTime = lastSessionTime
    _this.userInfo.tags = tags
    _this.userInfo.transferType = transferType
    _this.userInfo.mobile = mobile
    _this.userInfo.openid = openid
    _this.userInfo.content = content
    _this.userInfo.msgContentType = msgContentType
    _this.event.connectSuccess = connectSuccess
    _this.event.connectClose = connectClose
    _this.event.connectRetry = connectRetry
    _this.event.heartbeat = heartbeat
    _this.event.accessSuccess = accessSuccess
    _this.event.chatMsgReceived = chatMsgReceived
    _this.event.waitMsgReceived = waitMsgReceived
    _this.event.agentAccessMsgReceived = agentAccessMsgReceived
    _this.event.sessionOverMsgReceived = sessionOverMsgReceived
    _this.event.responseMsgReceived = responseMsgReceived
    _this.event.cancelMsgReceived = cancelMsgReceived
    _this.event.serviceSeerReceived = serviceSeerReceived
    _this.event.commentMsgReceived = commentMsgReceived
    _this.event.agentChangeMsgReceived = agentChangeMsgReceived
    _this.event.inviteCommentReceived = inviteCommentReceived
    _this.event.sessionErrorReceived = sessionErrorReceived
    _this.getWebsocket()
  },
  getWebsocket() {
    var _this = this
    if (_this.worker) {
      _this.worker.terminate()
    }
    _this.worker = new Worker(new URL('@/utils/mainWorker.js', import.meta.url))
    if (!window.WebSocket) {
      window.WebSocket = window.MozWebSocket
    }
    if (window.WebSocket) {
      _this.worker.postMessage({
        type: 'start',
        data: {
          url: _this.wsUrl,
          userInfo: _this.userInfo,
          commonFiled: _this.commonFiled
        }
      })
      _this.worker.onmessage = function (event) {
        let { type, data, retryFlag } = event.data
        if (type === _this.workmsgType.onmessage) {
          _this.onSocketMsg(data)
        } else if (type === _this.workmsgType.onopen) {
          // 连接成功
          _this.status = 1
          _this.event.connectSuccess(retryFlag || false)
          _this.sendCustAccessMsg(retryFlag || false)
        } else if (type === _this.workmsgType.onclose) {
          _this.status = 0
          _this.event.connectClose(false)
          if (data === 1000 || _this.isClose) {
            _this.event.connectClose()
            localStorage.removeItem('sessionId')
            _this.isClose = false
            // 关闭线程
            if (_this.worker) {
              _this.worker.terminate()
            }
          }
        } else if (type === _this.workmsgType.onerror) {
          _this.status = 0
          _this.event.connectClose(false)
        } else if (type === _this.workmsgType.retry) {
          _this.event.connectRetry()
        } else if (type === _this.workmsgType.retryFailed) {
          console.log('重连失败，已达最大次数');
          if (_this.worker) {
            _this.worker.terminate()
          }
          _this.event.connectClose(true)
        }
      }
    } else {
      alert('您的浏览器不支持WebSocket协议！')
    }
  },
  onSocketMsg(event) {
    const _this = this
    const msg = event
    if (msg.msgType == _this.msgType.heartMsg) {
      _this.handleHeartbeatMsg(msg)
    } else if (msg.msgType == _this.msgType.accessResultMsg) {
      _this.handleCustAccessMsg(msg)
      _this.changeSessionId(msg)
    } else if (msg.msgType == _this.msgType.waitMsg) {
      _this.handleWaitMsg(msg)
    } else if (msg.msgType == _this.msgType.agentAccessMsg) {
      _this.changeSessionId(msg)
      _this.handleAgentAccessMsg(msg)
    } else if (msg.msgType == _this.msgType.chatMsg) {
      _this.handleChatMsg(msg)
    } else if (msg.msgType == _this.msgType.sessionOverMsg) {
      _this.handleSessionOverMsg(msg)
    } else if (msg.msgType == _this.msgType.responseMsg) {
      _this.handResponseMsg(msg)
    } else if (msg.msgType === _this.msgType.cancelMsg) {
      _this.handleCancelMsg(msg)
    } else if (msg.msgType === _this.msgType.serviceSeer) {
      _this.handleServiceSeerMsg(msg)
    } else if (msg.msgType == _this.msgType.commentMsg) {
      _this.handCommentMsg(msg)
    } else if (msg.msgType == _this.msgType.agentChangeMsg) {
      _this.handAgentChangeMsg(msg)
    } else if (msg.msgType === _this.msgType.inviteComment) {
      _this.handleInviteComment(msg)
    } else if (msg.msgType == _this.msgType.sessionError) {
      _this.handleSeesionError(msg)
    }
  },
  changeSessionId(msg) {
    if (msg.sessionId == null) {
      return
    }
    this.sessionInfo.sessionId = msg.sessionId
    this.worker.postMessage({
      type: 'access',
      data: {
        sessionId: msg.sessionId
      }
    })
  },
  close() {
    this.worker.postMessage({ type: 'close', data: {} })
    this.isClose = true
  },
  retryConnect() {
    // const _this = this
    // setTimeout(function () {
    //   _this.retryTimes++
    //   console.log('重连次数：' + _this.retryTimes)
    //   if (_this.retryTimes <= _this.maxRetryTimes) {
    //     _this.event.connectRetry()
    //     _this.getWebsocket()
    //   } else {
    //     // 关闭线程
    //     if (_this.worker) {
    //       _this.worker.terminate()
    //     }
    //   }
    // }, 5000)
  },
 
  /**
   * 设置事件
   * @param eventType
   * @param func
   */
  setEvent(eventType, func) {
    this.event[eventType] = func
  },
  /**
   * 发送用户接入成功消息
   */
  sendCustAccessMsg(retryFlag) {
    var msg = {
      openid: this.userInfo.openid,
      custId: this.userInfo.userId,
      content: this.userInfo.content,
      msgContentType: this.userInfo.msgContentType,
      custName: this.userInfo.userName,
      custFlag: this.userInfo.custFlag,
      custHeadImg: this.userInfo.userHeadImg,
      agentGroupId: this.userInfo.userGroup,
      custMobile: this.userInfo.mobile,
      clientId: this.userInfo.clientId,
      clientType: this.userInfo.clientType,
      clientIp: this.userInfo.clientIp,
      clientIpRegion: this.userInfo.clientIpRegion,
      clientOs: this.userInfo.clientOs,
      clientBrowse: this.userInfo.clientBrowse,
      online: this.userInfo.online,
      sourceSite: this.userInfo.sourceSite,
      lastServiceAgentId: this.userInfo.lastServiceAgentId,
      lastServiceAgentTime: this.userInfo.lastServiceAgentTime,
      lastSessionTime: this.userInfo.lastSessionTime,
      tags: this.userInfo.tags,
      groupTags: this.userInfo.groupTags,
      transferType: this.userInfo.transferType,
      reconnect: retryFlag ? 1 : 0
    }
    this.sendMsg(this.msgType.custAccessMsg, msg)
  },
  /**
   * 发送客服消息
   * @param toId
   * @param msgId
   * @param msgType
   * @param msgContent
   * @param url
   */
  sendChatMsg(toId, msgId, msgType, msgContent, url, agentHeadImg, quoteMsgId, quoteMsgContent) {
    var msg = {
      sessionId: this.sessionInfo.sessionId,
      clientId: this.userInfo.clientId,
      msgId: msgId,
      fromId: this.userInfo.userId,
      fromHeadImg: this.userInfo.userHeadImg,
      toId: toId,
      toHeadImg: agentHeadImg,
      toType: 2,
      msgContentType: msgType,
      content: msgContent,
      url: url,
      quoteMsgId,
      quoteMsgContent
    }
    this.sendMsg(this.msgType.chatMsg, msg)
  },
  /**
   * 服务先知
   * @param toId
   * @param msgId
   * @param msgType
   * @param msgContent
   * @param url
   */
  seerMsg(toId, msgId, msgType, msgContent, url) {
    let msg = {
      sessionId: this.sessionInfo.sessionId,
      clientId: this.userInfo.clientId,
      msgId: msgId,
      fromId: this.userInfo.userId,
      toId: toId,
      toType: 2,
      msgContentType: msgType,
      content: msgContent,
      url: url
    }
    this.sendMsg(this.msgType.serviceSeer, msg)
  },
  /**
   * 发送会话结束消息
   */
  sendSessionOverMsg() {
    var msg = {
      sessionId: this.sessionInfo.sessionId,
      senderType: 1
    }
    this.sendMsg(this.msgType.sessionOverMsg, msg)
  },
  /**
   * 撤回消息
   * @param msgType
   * @param msgId
   */
  revokeMsg(msgType, msgId) {
    var msg = {
      sessionId: this.sessionInfo.sessionId,
      msgType: msgType,
      msgId: msgId
    }
    this.sendMsg(this.msgType.cancelMsg, msg)
  },
  /**
   * 发送评论消息
   * @param {*} agentId
   * @param {*} commentScore
   * @param {*} commentContent
   */
  sendCommentMsg(agentId, commentScore, commentContent) {
    var msg = {
      sessionId: this.sessionInfo.sessionId,
      custId: this.userInfo.userId,
      agentId: agentId,
      commentScore: commentScore,
      commentContent: commentContent
    }
    this.sendMsg(this.msgType.commentMsg, msg)
  },
  /**
   * 发送消息
   * @param msgType
   * @param msg
   */
  sendMsg: function (msgType, msg) {
    if (!window.WebSocket) {
      alert('您的浏览器不支持WebSocket协议！')
      return
    }
    if (this.status === 4) {
      this.status = 0
      this.getWebsocket()
    } else {
      this.worker.postMessage({ type: 'msg', data: { data: msg, msgType: msgType } })
    }
  },
  /**
   * 接收客户接入成功消息
   * @param msg
   */
  handleCustAccessMsg(msg) {
    if (msg.status == 0) {
      this.status = 2
      this.sessionInfo.sessionId = msg.sessionId
      this.event.accessSuccess(msg)
    } else {
      console.error('客户接入失败')
    }
  },
  /**
   * 接收等待消息
   * @param msg
   */
  handleWaitMsg(msg) {
    this.event.waitMsgReceived(msg)
  },
  /**
   * 坐席分配成功消息
   * @param msg
   */
  handleAgentAccessMsg(msg) {
    this.status = 3
    this.sessionInfo.agentId = msg.agentId
    this.event.agentAccessMsgReceived(msg)
  },
  /**
   * 会话结束消息
   * @param msg
   */
  handleSessionOverMsg(msg) {
    this.status = 4
    this.event.sessionOverMsgReceived(msg)
  },
  /**
   * 心跳消息处理
   * @param msg
   */
  handleHeartbeatMsg(msg) {
  },
  /**
   * 聊天消息处理
   * @param msg
   */
  handleChatMsg(msg) {
    this.event.chatMsgReceived(msg)
  },
  /**
   * 应答消息处理
   * @param {应答消息} msg
   */
  handResponseMsg(msg) {
    this.event.responseMsgReceived(msg)
  },
  /**
   * 消息撤回
   * @param msg
   */
  handleCancelMsg(msg) {
    this.event.cancelMsgReceived(msg)
  },
  /**
   * 服务先知
   * @param msg
   */
  handleServiceSeerMsg(msg) {
    this.event.serviceSeerReceived(msg)
  },
  /**
   * 评论消息处理
   * @param {评论消息} msg
   */
  handCommentMsg(msg) {
    this.event.commentMsgReceived(msg)
  },
  /**
   * 坐席转移消息处理
   * @param {坐席转移消息} msg
   */
  handAgentChangeMsg(msg) {
    this.sessionInfo.sessionId = msg.newSessionId
    this.sessionInfo.agentId = msg.newAgentId
    this.event.agentChangeMsgReceived(msg)
  },
  /**
   * 邀请评价消息
   * @param {邀请评价消息} msg
   */
  handleInviteComment(msg) {
    this.event.inviteCommentReceived(msg)
  },
  /**
   * 会话异常
   * @param msg
   */
  handleSeesionError(msg) {
    this.event.sessionErrorReceived(msg)
  }
}
